import { useState } from 'react';
import { LABEL_CLASS } from '../candidatoFormExternoEtapa2Page.definitions';

/** Mesmo limite do servidor (uploadBase64File) — avisar já na escolha evita descobrir só no envio. */
const TAMANHO_MAXIMO_BYTES = 5 * 1024 * 1024;

interface CampoArquivoProps {
  label: string;
  arquivo: File | null;
  onChange: (arquivo: File | null) => void;
}

/** Upload opcional (ver decisão registrada: documento não bloqueia o envio, RH
 * complementa depois se faltar) — sobe no envio final, um arquivo por vez (ver
 * enviarDocumentosEtapa2). */
export default function CampoArquivo({ label, arquivo, onChange }: CampoArquivoProps) {
  const [erro, setErro] = useState<string | null>(null);

  return (
    <div>
      <label className={LABEL_CLASS}>{label}</label>
      <input
        type="file"
        accept="image/*,application/pdf"
        className="block w-full text-sm text-gray-600 file:mr-3 file:rounded-lg file:border-0 file:bg-indigo-50 file:px-3 file:py-2 file:text-sm file:font-semibold file:text-indigo-700 hover:file:bg-indigo-100"
        onChange={(e) => {
          const escolhido = e.target.files?.[0] ?? null;
          if (escolhido && escolhido.size > TAMANHO_MAXIMO_BYTES) {
            setErro(`"${escolhido.name}" tem mais de 5 MB. Envie um arquivo menor (ex.: foto comprimida ou PDF reduzido).`);
            e.target.value = '';
            onChange(null);
            return;
          }
          setErro(null);
          onChange(escolhido);
        }}
      />
      {arquivo && <p className="mt-1 text-xs text-gray-500">Selecionado: {arquivo.name}</p>}
      {erro && <p className="mt-1 text-sm text-red-600">{erro}</p>}
    </div>
  );
}
